import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageMenuItem from "./Language";
import styles from "./ChooseLanguageScreen.module.css";
import { QuizzesScreenUrl } from "../../App";
import { getActiveQuiz } from "../../helpers/dataHelpers";
import {
  getActiveGameKeys,
  getKeyAnswersArrIndex,
} from "../../helpers/gameHelpers";

import ArrowBlueUp from "../../images/suva-blue_arrow.png";
import YellowCircle from "../../images/suva-yellow_circle.png";
import ArrowRedDown from "../../images/suva-red_arrow.png";

const activeKeys = getActiveGameKeys();

const languagesArr = [
  { code: "de", name: "Deutsch", selected: true, active: true },
  { code: "fr", name: "Français", selected: false, active: false },
  { code: "it", name: "Italiano", selected: false, active: false },
  { code: "en", name: "English", selected: false, active: false },
];


const getActiveQuizLangs = (activeQuiz) => {
  let availableLanguages = [];
  if (!activeQuiz) {
    // if quiz is not chosen show all langs as available
    availableLanguages = languagesArr.map(lang => lang.code);
  } else {
    languagesArr.forEach(lang => {
      if (
        activeQuiz?.questions?.length && 
        !activeQuiz?.questions.some(item => !item.question[lang.code])
      ) {
        availableLanguages.push(lang.code)
      }
    })
  }

  return availableLanguages;
};

function ChooseLanguageScreen({ quizzes = [], sounds }) {
  const [t, i18n] = useTranslation("common");
  const [langs, setLangs] = useState(languagesArr);
  const [availableLangs, setAvailableLangs] = useState([]);
  const [selection, setSelection] = useState({
    selectedMenu: 0,
    activeMenu: 0,
  });
  const [isStartSelected, setIsStartSelected] = useState(false);
  const [isOverlayShown, setIsOverlayShown] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (quizzes?.length) {
      setAvailableLangs(getActiveQuizLangs(getActiveQuiz(quizzes)))
    }
  }, [quizzes])

  useEffect(() => {
    setLangs(
      langs.map((lang, index) => {
        return {
          ...lang,
          active: index === selection.activeMenu ? true : false,
          selected: index === selection.selectedMenu ? true : false,
        };
      })
    );

    if (selection.activeMenu === langs.length) {
      setIsStartSelected(true);
    } else {
      setIsStartSelected(false);
    }
  }, [selection]);

  const prev = () => {
    setSelection((prev) => {
      if (prev.activeMenu === 0) {
        return {
          ...prev,
          activeMenu: 0,
        };
      } else {
        return {
          ...prev,
          activeMenu: prev.activeMenu - 1,
        };
      }
    });

    sounds.buttonSound();
  };

  const select = () => {
    setSelection((prev) => {
      if (prev.activeMenu === langs.length) {
        onLanguageChose();
        return prev;
      } else if (availableLangs.includes(langs[prev.activeMenu].code)) {
        sounds.answerPanelSound();
        return {
          ...prev,
          selectedMenu: prev.activeMenu,
        };
      } else {
        return prev;
      }
    });
  };

  const next = () => {
    setSelection((prev) => {
      if (prev.activeMenu === langs.length) {
        return {
          ...prev,
          activeMenu: langs.length,
        };
      } else {
        return {
          ...prev,
          activeMenu: prev.activeMenu + 1,
        };
      }
    });
    sounds.buttonSound();
  };

  const mouseClick = (index) => {
    if (index <= langs.length) {
      setSelection({
        activeMenu: index,
        selectedMenu: index,
      });

      sounds.answerPanelSound();
    } else {
      onLanguageChose();
      setIsStartSelected(true);
    }
  };

  const onKeyDown = (e) => {
    if (activeKeys.includes(e.key)) {
      const index = getKeyAnswersArrIndex(e.key);
      if (index === 0) {
        prev();
      }

      if (index === 1) {
        select();
      }

      if (index === 2) {
        next();
      }
    }
  };

  useEffect(() => {
    window.removeEventListener("keydown", onKeyDown);
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [selection]);

  const onLanguageChose = () => {
    sounds.confirmSound();

    setIsOverlayShown(true);
    window.removeEventListener("keydown", onKeyDown);
    const chosenLangCode = langs[selection.selectedMenu].code;
    i18n.changeLanguage(chosenLangCode);

    setTimeout(() => {
      navigate(QuizzesScreenUrl);
    }, 3000);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        {langs.map((item, index) => (
          <LanguageMenuItem
            key={item.code}
            langNameText={item.name}
            selected={item.selected}
            active={item.active}
            onClick={() => {
              mouseClick(index);
            }}
            disabled={!availableLangs.includes(item.code)}
          />
        ))}
        <LanguageMenuItem
          langNameText="START"
          isBold={true}
          active={isStartSelected}
          style={{ marginTop: "87px" }}
          onClick={() => {
            mouseClick(999999);
          }}
        />
      </div>
      <div className={styles.right}>
        <div className={styles.navigation}>
          <div onClick={prev}>
            <img src={ArrowBlueUp} alt="" />
          </div>
          <div style={{ marginTop: "36px" }} onClick={select}>
            <img src={YellowCircle} alt="" />
          </div>
          <div style={{ marginTop: "36px" }} onClick={next}>
            <img src={ArrowRedDown} alt="" />
          </div>
        </div>
      </div>
      {isOverlayShown && <div className={styles.invisibleOverlay}></div>}
    </div>
  );
}

export default ChooseLanguageScreen;
